import React from 'react';

function Error({ title = 'Something went wrong', message = '404' }) {
    return (
        <div className="page">
            <div className="main-content">
                <div className="container text-center">
                    <section>
                        <h1>{title}</h1>
                        <p>{message}</p>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default Error;



// WEBPACK FOOTER //
// ./src/pages/Error.js